import React, { ReactElement, ReactSVGElement } from 'react';
import { ReactComponent as Down } from 'Icons/Header/down.svg';
import { isNullOrUndefined } from 'utils/Global';

type ActionButtonProps = {
  Icon: ReactSVGElement;
  title: string;
  onClick: () => void;
  children?: ReactElement;
  isDisabled?: boolean;
  active?: boolean;
};

const ActionButton = ({
  Icon,
  title,
  onClick,
  children,
  isDisabled,
  active,
}: ActionButtonProps) => {
  return (
    <div
      id="headerbuttons-action-button-wrapper"
      className={`flex-x-center flex-column h-100 header-button-container ${
        isDisabled ? 'expand-sidebar-item-active' : 'cursor-pointer'
      } ${active ? 'active-header-action-button' : ''}`}
      onClick={onClick}
    >
      <div id='headerbuttons-action-button-icon' className="headerbuttonsbutton-icon">{Icon}</div>
      <div id={`headerbuttonsaction-button-text-${children}`} className="header-button-text flex-y-center flex-space-between flex-column">
        <div id={`headerbuttons-action-${title}-button`}>{title}</div>
        {children}
      </div>
    </div>
  );
};

const CheckboxPanel = ({ data }) => {
  const { label, id, onChange, checked, isDisabled } = data;
  return (
    <div
      id='headerbuttons-checkboxpanel-wrapper'
      className={
        'header-checkbox ' +
        (isDisabled ? 'expand-sidebar-item-active blackColor' : 'cursor-pointer')
      }
    >
      <input
        type="checkbox"
        id={`headerbuttons-checkboxpanel-${id}`}
        name={id}
        value={id}
        checked={checked}
        onChange={onChange}
      />
      <label id={`headerbuttons-checkboxpanel-label-${label}`}>{label}</label>
    </div>
  );
};

export const IconPanel = ({ data }) => {
  const { Icon, label, onClick, id, isDisabled } = data;
  return (
    <div
      id='headerbuttons-iconpanel-wrapper'
      onClick={onClick}
      className={
        'header-checkbox ' +
        (isDisabled ? 'expand-sidebar-item-active blackColor' : 'cursor-pointer')
      }
    >
      {Icon}
      {!isNullOrUndefined(label) ? (
        <label id={`headerbuttons-iconpanel-${id}-${label}`} className={isDisabled ? 'cursor-mouse' : 'cursor-pointer'}>
          {label}
        </label>
      ) : null}
    </div>
  );
};

export const ExtendedButton = ({
  Icon,
  title,
  showPanel,
  panelData,
  onClick,
  elementCount,
  isDisabled,
}) => {
  return (
    <div
      id='headerbuttons-extendedbutton-wrapper'
      className={
        (elementCount
          ? 'header-button-container h-100'
          : 'flex-x-center header-button-container h-100 ') +
        (isDisabled ? ' expand-sidebar-item-active' : '')
      }
    >
      {}
      <ActionButton Icon={Icon} title={title} onClick={onClick}>
        <Down id='headerbuttons-extendedbutton-down' style={{ height: '17%' }} />
      </ActionButton>
      {}
      {showPanel ? (
        <div
          id='headerbuttons-extendedbutton-show-panel'
          className={
            elementCount ? 'header-dropdown-panle-margin' : 'header-dropdown-panel'
          }
        >
          {panelData}
        </div>
      ) : null}
    </div>
  );
};

const HeaderButtons = ({ buttons }) => {
  const actionBtns = [];
  let btnview;
  if (buttons) {
    for (let i = 0; i < buttons.length; i += 1) {
      const button = buttons[i];
      if (isNullOrUndefined(button)) {
        continue;
      }
      if (button.content) {
        btnview = (
          <div id={`headerbuttons-btnview-${button.content}`} style={{ marginLeft: 10, marginRight: 30 }} key={`${i} ${button.content}`}>
            {button.content}
          </div>
        );
      } else if (button.CheckboxData || button.IconData) {
        let panelData = [];
        if (button.CheckboxData) {
          panelData = button.CheckboxData.map((data, index) => (
            <CheckboxPanel key={index * 2} data={data} />
          ));
        } else {
          panelData = button.IconData.map((data, index) => (
            <IconPanel data={data} key={index * 3} />
          ));
        }
        const { onClick, Icon, title, showPanel, isDisabled } = button;
        btnview = (
          <ExtendedButton
            Icon={Icon}
            isDisabled={isDisabled}
            title={title}
            showPanel={showPanel}
            onClick={onClick}
            panelData={panelData}
            key={`${i} ${button.title}`}
            elementCount={i < buttons.length - 2}
          />
        );
      } else {
        btnview = (
          <ActionButton
            Icon={button.Icon}
            title={button.title}
            onClick={button.onClick}
            isDisabled={button.isDisabled}
            active={button.active}
            key={`${i} ${button.title}`}
          />
        );
      }
      actionBtns.push(btnview);
    }
  }
  return (
    <div id='headerbuttons-buttons-wrapper' className="flex-y-center flex-space-between" style={{ height: '100%' }}>
      {actionBtns}
    </div>
  );
};

export { ActionButton };
export default HeaderButtons;
